export interface StatusNotificationsSliceModel {
    notificationList: StatusNotificationState[]
}

export interface StatusNotificationState {
    id: string,
    message: string,
    type: NotificationTypes
}

export interface StatusNotification {
    message: string,
    type: NotificationTypes
}

export const initialState: StatusNotificationsSliceModel = {
    notificationList: []
};

export enum NotificationTypes {
    Success = "Success",
    Error = "Error",
    Info = "Info",
    Warning = "Warning"
}